import { render, staticRenderFns } from "./QuickAccessPanel.vue?vue&type=template&id=f8c78c9c&scoped=true"
import script from "./QuickAccessPanel.vue?vue&type=script&lang=js"
export * from "./QuickAccessPanel.vue?vue&type=script&lang=js"
import style0 from "./QuickAccessPanel.vue?vue&type=style&index=0&id=f8c78c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c78c9c",
  null
  
)

export default component.exports